import * as React from 'react';
export const IcArena = (props: React.SVGProps<SVGSVGElement>): JSX.Element => (
  <svg
    viewBox='0 0 24 24'
    fill='none'
    xmlns='http://www.w3.org/2000/svg'
    {...props}
  >
    <path
      d='M3 13.11V19c0 1.43 3 2.62 7 2.92V19a2 2 0 014 0v2.92c4-.3 7-1.49 7-2.92v-5.89C18.83 14.46 15.25 15 12 15s-6.83-.54-9-1.89zm9-.11c5 0 9-1.34 9-3 0-.89-1.16-1.68-3-2.23v-2l1.32-.83a.5.5 0 000-.84l-2.55-1.6a.5.5 0 00-.77.4v4.42A24.658 24.658 0 0012 7V5.75l1.32-.83a.5.5 0 000-.84l-2.55-1.6a.5.5 0 00-.77.42v4.18a18.61 18.61 0 00-4 .69v-2l1.32-.83a.5.5 0 000-.84L4.77 2.48A.5.5 0 004 2.9v5.73A1.78 1.78 0 003 10c0 1.66 4 3 9 3z'
      fill='currentColor'
    />
  </svg>
);
